import { SvgIcons } from '@ui-components/SvgIcon';
import OpenModal from 'app/components/VideoModal/OpenModal';
import { getAccessServiceDescription } from 'app/domain/AccessServiceTypes';
import { Accessibility, AccessibilityVariantFragment } from 'app/graphql/__generated__/types/contento';
import React from 'react';
import { StyledVariantIcon, StyledVariantLink, StyledVariantNoWrap } from './VariantLinks.styles';

export const getIcon = (accessibility: Accessibility): SvgIcons => {
    if (accessibility === Accessibility.SignInterpreted) {
        return SvgIcons.SIGN_LANGUAGE;
    }

    if (accessibility === Accessibility.AudioDescribed) {
        return SvgIcons.SIGHT;
    }

    return null;
};

type Props = {
    index: number;
    variant: AccessibilityVariantFragment;
    onClick: (accessibility: Accessibility) => void;
    noOfVariants: number;
    hasMultipleLanguages: boolean;
    context: string;
};

const VariantLink = ({
    index,
    variant,
    onClick,
    noOfVariants,
    hasMultipleLanguages,
    context,
}: Props): JSX.Element => {
    let prepend = index > 0 ? ' och ' : '';

    // special case when there are more than two variants
    if (noOfVariants > 2 && index !== noOfVariants - 1 && index > 0) {
        prepend = ', ';
    }

    if (variant.accessibility !== Accessibility.Default && index === 0) {
        prepend += 'som ';
    }

    return (
        <>
            {prepend}
            <StyledVariantNoWrap>
                {variant.accessibility !== Accessibility.Default && (
                    <StyledVariantIcon icon={getIcon(variant.accessibility)} width={20} />
                )}
                <OpenModal videoId={variant.svtId} videoUrl={variant.urls.svtplay}>
                    {(handleOpenModal) => (
                        <StyledVariantLink
                            onClick={() => {
                                handleOpenModal();
                                onClick(variant.accessibility);
                            }}
                            data-rt={`${context}-a11y-link`}
                        >
                            {getAccessServiceDescription(
                                variant.accessibility,
                                variant.mainLanguage,
                                hasMultipleLanguages
                            )}
                        </StyledVariantLink>
                    )}
                </OpenModal>
            </StyledVariantNoWrap>
        </>
    );
};

export default VariantLink;
